module.exports = __webpack_public_path__ + "static/img/6.0ba2255.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/6.png
// module id = Z8us
// module chunks = 0